import { getStoreLocalMoment } from './getStoreLocalMoment';

export const getOpeningHoursRangeText = ({
  openingTime,
  closingTime,
  utcOffset,
}: {
  openingTime: string | undefined;
  closingTime: string | undefined;
  utcOffset: number | undefined;
}) => {
  const startMoment = getStoreLocalMoment(openingTime, utcOffset);
  const endMoment = getStoreLocalMoment(closingTime, utcOffset);

  if (!startMoment || !endMoment) {
    return undefined;
  }

  return `${startMoment.format('LT')} - ${endMoment.format('LT')}`;
};
